import { createAction } from '@reduxjs/toolkit';
import { LOCATION_CHANGE } from 'connected-react-router';
export const locationChange = createAction(LOCATION_CHANGE);
